import { render, staticRenderFns } from "./boundmerchant-price.vue?vue&type=template&id=2948747e"
import script from "./boundmerchant-price.vue?vue&type=script&lang=js"
export * from "./boundmerchant-price.vue?vue&type=script&lang=js"
import style0 from "./boundmerchant-price.vue?vue&type=style&index=0&id=2948747e&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2948747e')) {
      api.createRecord('2948747e', component.options)
    } else {
      api.reload('2948747e', component.options)
    }
    module.hot.accept("./boundmerchant-price.vue?vue&type=template&id=2948747e", function () {
      api.rerender('2948747e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/transport/bound/boundmerchant-price.vue"
export default component.exports